import { render } from "./resume_validation.vue?vue&type=template&id=f60b807e"
import script from "./resume_validation.vue?vue&type=script&lang=js"
export * from "./resume_validation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\Developpement\\_VELO\\demo-location.accen.me\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__